import { createFileRoute } from '@tanstack/react-router';
import { JourneysCampaignJourneyMetricsHandoff } from '@/pages/workspaces/automations/[campaignId]/metrics/routing';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/overview/journey_metrics',
)({
  component: JourneysCampaignJourneyMetricsHandoff,
});
